import React from 'react';

const Widgets = () => {
  return (
    <section>
      <div className="section-body">
        <div className="row">
          <div className="col-lg-12">
            <div className="card ">
              <iframe src="https://public.domo.com/cards/bWxVg" width="100%" height="1000px" marginHeight="0"
                      marginWidth="0" frameBorder="0"/>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card ">
              <iframe src="https://public.domo.com/cards/avnAV" width="100%" height="1000px" marginHeight="0"
                      marginWidth="0" frameBorder="0"/>
            </div>
          </div>
        </div>
        {/*<div className="row">
          <div className="col-lg-12">
            <div className="card ">
              <iframe src="https://www.arcgis.com/apps/opsdashboard/index.html#/bda7594740fd40299423467b48e9ecf6"
                      width="100%" height="720px"/>
            </div>
          </div>
        </div>*/}
      </div>
    </section>
  );
};

export default Widgets;
